import { IApplicationState } from '../../types/redux';

export const getReviewsCount = (state: IApplicationState): number | null | undefined => {
  return state.offersData.seo?.reviewsCount;
};
